module.exports = __webpack_public_path__ + "static/media/Footer-Desktop.b1a59b25.jpg";